import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { WithStyles, createStyles, Typography, Grid, Paper, Button, Link } from '@material-ui/core';
import { MyPATDialog, MyPATIconButton, ServerAlertAction } from '../../common';
import { CloseOutlined as CloseIcon, FileCopy as CopyIcon, } from '@material-ui/icons';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import TemplateList from "./TemplateList";
import CreateTestTemplate from "./CreateTestTemplate";
import { bindActionCreators } from 'redux';
import { testTemplateList, saveTestTemplate, showMsg } from '../actions/testTemplateActions';
import { TestTemplateBody } from '../types/TestTemplateBody';
import { ContentSubType } from '../types/ContentSubTypeBody';
import ACL from '../../acl/components/ACL';
import ACLService from '../../acl/services/aclService';
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";
import { PERMISSION_CONTENT_TYPES, TEST_TEMPLATE_CONFIG, TEST_TEMPLATE_ERROR_MESSAGE, TEST_TEMPLATE_TYPES, USER_RIGHTS } from '../../../constants/comman';
import { createDeepCopy, getPropertyValue } from '../../../utils';

const styles = (theme: Theme) => createStyles({
    saveBtn:{
		boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.224892)',
		borderRadius: 2,
		fontFamily: 'Nunito',
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: 16,
		lineHeight: '19px',
		letterSpacing: '0.5px',
		color: '#FFFFFF',
		background: '#1D7DEA',
		padding: '4px 22px',
		'&:hover': {
			background: '#1D7DEA'
		}
	},
    arrowBtn: {
        minWidth: 13,
        padding: '0px 7px'
    },
    root: {
        ...theme.mixins.gutters(),
        width: '100%',
        maxWidth: '100%',
        // paddingTop: theme.spacing.unit * 3,
        paddingBottom: theme.spacing.unit * 2
    },
    headerActions: {
        textAlign: 'right',
    },
    headerCreate: {
        height: "90px",
        textAlign: "center",
        verticalAlign: "middle",
        lineHeight: "90px"
    },
    contentScroll: {
        height: 'calc(100vh - 190px)',
        overflow: 'auto',
        minHeight: '200px'
    },
    createTemplateBtn: {
        marginBottom: '15px',
    },
    customBtn:{
        marginBottom: 0,
        fontWeight: 400,
        padding: '22px 32px'
    },
    paginationBtn: {
        background: '#FFF',
        border: '1px solid #c4c4c4',
        borderRadius: 4,
        color: '#1D7DEA',
        cursor: 'pointer',
        fontWeight: 600
    },
    recordCount: {
        fontSize: '1rem',
        padding: '8px 8px',
        border: 'solid 1px #c4c4c4',
        height: 36,
        borderRadius: 4
    },
    searchContainer: {
        margin: "20px 0",
        position: "relative",
        width: "394px !important",
        "& img": {
          position: "absolute",
          top:12,
          left:10,
          width:20,
          marginRight: "10px",
        },
        "& input": {
          padding: "8px 10px 8px 40px",
          fontSize:16,
          borderRadius:30,
          border: "0.5px solid rgb(223 223 223)",
          height:44,
          width: "100%",
          "&:focus":{
            outline: "none"
          }
        }
      },
    center: {
        maxWidth: "315px",
        textAlign: "center",
        margin: 'auto',
    },
    img: {
        width: "100%"
    },
    heading: {
        marginTop: "20px"
    },
    templateHeading:{
        fontSize: 20,
        fontWeight: 400,
        color: '#333',
        marginTop: 5,
    },
    emptyState:{
        margin: '50px 0'
    },
    textCenter:{
        textAlign: 'center'
    },
    emptyheadingText:{
        fontSize: 24,
        fontWeight: 500,
        color: '#333',
        display: 'block',
        margin: 0,
    },
    subText:{
        fontSize: 16,
        fontWeight: 500,
        color: '#999',
        marginTop: 6,
    },
    customScroll: {
        '&.ps': {
            overflow: 'initial !important',
        },
        '& .ps__rail-y': {
            display: 'none',
        },
    },
    btnOutline:{
		color: '#1D7DEA',
		fontSize: 14,
		fontWeight: 400,
		padding: '8px 37px',
		borderRadius: 4,
		border: 'solid 1px #1D7DEA',
		'&:hover':{
			background: '#dbe6f3'
		}
	},
    btnPrimary:{
		background: '#1D7DEA',
		color: '#fff',
		fontSize: 14,
		fontWeight: 400,
		padding: '8px 37px',
		borderRadius: 4,
		'&:hover':{
			background: '#0a68d7'
		}
	}
    
});

const durationTypes = [
    {
        value: 'min',
        label: 'Min',
    },
    {
        value: 'hour',
        label: 'Hour',
    }
];

interface TemplateContentProps extends WithStyles<typeof styles> {
    activeTestTypeId: any,
    skip: number,
    templatesList: TestTemplateBody[],
    testTemplateList: () => void,
    transferToParent: any,
    activeTSetting: any,
    testTemplateType: ContentSubType[],
    showMsg: (msg: string, vari: string) => void,
    updateTestTemplateTypeList: (type: string) => void;
    nextPage: Function;
    prevPage: Function;
    toPage: Function;
    isFieldDisabled: Function;
    userData: any;
    isPostExpiryDays: any,
    showLicenseExpiredDialog: any,
    toggleLicenseExpiredDialog: any,
    setLoggedInUser: any,
    handleSearchQuery:(searchQuery:string)=>void
    searchQuery:string;
    selectedTemplateTypeFilter: string;
    onTemplateRuleEdit: Function;
    recordCount: number,
    activeTestType: any;
}

interface TemplateContentState {
    durationType: string,
    isCreate: boolean,
    isTemplatePresent: boolean,
    testTemplateReq: any,
    searchText:string,
}

class TemplateContent extends Component<TemplateContentProps, TemplateContentState>{

    errorMsg: any = {}

    constructor(props: TemplateContentProps) {
        super(props);

        this.state = {
            durationType: "min",
            isCreate: false,
            isTemplatePresent: true,
            testTemplateReq: {},
            searchText:'',
        };

        this.gotFromChild = this.gotFromChild.bind(this);
        this.getTestDuration = this.getTestDuration.bind(this);
        this.handleSearchChange = _.debounce(this.handleSearchChange, 200);
    }

    componentDidMount(){
        this.props.setLoggedInUser();
    }



    viewCreateTemplate = (event: any) => {
        if (this.props.isPostExpiryDays) {
            this.props.toggleLicenseExpiredDialog(true);
        } else {
            let isView = !this.state.isCreate;
            this.setState({
                isCreate: isView
            }) 
        }
    
    }

    updateSectionName = () => {
        let { testTemplateReq } = this.state;
        if (testTemplateReq.sections.length) {
            testTemplateReq.sections.map((data: any, index: number) => {
                testTemplateReq.sections[index].name = data.name ? data.name : `Section ${index + 1}`
            })
        }
        this.setState({ testTemplateReq })
    }

    getTestDuration() {
        const { activeTestTypeId: selectedId, testTemplateType } = this.props
        let templateType: any = _.find(testTemplateType, { _id: selectedId }) || {};
        if (templateType) {
            return templateType.time
        }
        return 180
    }

    validateTestTemplateForError() {
        const { testTemplateReq } = this.state;
        let hasError = false;
        if (!(getPropertyValue(testTemplateReq, 'testDurationNumber') > 0)) {
            hasError = true;
            this.props.showMsg(TEST_TEMPLATE_ERROR_MESSAGE.DURATION, 'error');
        } else if (!getPropertyValue(testTemplateReq, 'courseId')) {
            hasError = true;
            this.props.showMsg(TEST_TEMPLATE_ERROR_MESSAGE.GOAL, 'error');
        }
        return hasError;
    }
    
    saveTestTemplate = (event: any) => {
        event.preventDefault();
        if (this.validateTestTemplateForError()) {
            return;
        }
        if (this.state.testTemplateReq.name) {
            this.updateSectionName()
            let requB = this.state.testTemplateReq;
            const templateFields = Object.values(TEST_TEMPLATE_CONFIG.FIELDS);
            templateFields.forEach(field => {
                if (typeof (requB[field]) === 'object') {
                    requB[field] = requB[field].key;
                }
            })
            requB.templateType = this.props.selectedTemplateTypeFilter;
            let activeTest = this.props.activeTSetting;
            requB.testTemplateTypeId = this.props.activeTestTypeId;
            if (this.props.testTemplateType.length > 0 && !requB.testTypeCode) {
                this.props.testTemplateType.forEach(g => {
                    if (g._id == this.props.activeTestTypeId) {
                        requB.testTypeCode = g.code;
                    }
                })
            }
           /* requB.testDurationType = activeTest && activeTest.testSetting && activeTest.testSetting.type ? activeTest.testSetting.type : "min";
            requB.testDurationNumber = activeTest && activeTest.testSetting && activeTest.testSetting.no ? activeTest.testSetting.no : this.getTestDuration();
            requB.testSectionLevel = activeTest && activeTest.testSetting && activeTest.testSection ? activeTest.testSection : "subject"; */
            if (this.validateTemplateForm(requB)) {
                saveTestTemplate(requB)
                    .then((isSave) => {
                        this.setState({
                            isCreate: !isSave,
                            testTemplateReq: {}
                        });
                        this.props.updateTestTemplateTypeList('add');
                        this.props.transferToParent(this.props.activeTestTypeId);
                    })
            }
            else {
                return false;
            }

        }
        else {
            this.props.showMsg('Require Template Name', 'error');
        }
    }


    //Same code is implemented at TemplateList.tsx if you are changing at this same need to be changed at there also

    validateTemplateForm(reqB: any) {
        let requB: any = reqB;
        let errorC = this.test2(requB);
        if (errorC > 0) {
            let msg = "";
            if (this.errorMsg["courseId"]) {
                msg = 'Kindly provide goal';
                this.props.showMsg(msg, 'error');
                return false;
            }
            if (this.errorMsg.sections && this.errorMsg.sections.length > 0) {
                for(let i=0;i<this.errorMsg.sections.length;i++) {
                    const ob = this.errorMsg.sections[i];
                    if (ob['courseSyllabusId']) {
                        msg = `Select section or enable autopick at section ${i + 1}`;
                        this.props.showMsg(msg, 'error');
                        return false;
                    }
                    if (ob["subSection"] && ob['subSection'].length > 0) {
                        for(let j=0;j<ob["subSection"].length;j++) {
                            const ob2 = ob["subSection"][j];
                            if (ob2['name']) {
                                msg = `Enter subsection name at subsection ${j + 1} of section ${i + 1}`;
                                this.props.showMsg(msg, 'error');
                                return false;
                            }
                            if (ob2['noOfQuestions']) {
                                msg = `Select no of question at subsection ${j + 1} of section ${i + 1}`;
                                this.props.showMsg(msg, 'error');
                                return false;
                            }
                            if(ob2.mandatoryQuestionCount) {
                                msg = `Select no of mandatory questions at subsection ${j + 1} of section ${i + 1}`;
                                this.props.showMsg(msg, 'error');
                                return false;
                            }
                            if (ob2['quesCodeAllowed']) {
                                msg = `Select question type at subsection ${j + 1} of section ${i + 1} `;
                                this.props.showMsg(msg, 'error');
                                return false;
                            }
                            
                        }
                    }
                }
            }
        } else {
            return true;
        }
    }

    //Same code is implemented at TemplateList.tsx if you are changing at this same need to be changed at there also

    test2(requB: any) {
        let errorCount = 0;
        this.errorMsg = {};
        let testSectionLevel = requB['testSectionLevel'];
        for (let i in requB) {

            if (['name', 'courseId'].includes(i)) {
                if (_.isEmpty(requB['name'])) {
                    this.errorMsg['name'] = "required *";
                    errorCount++;
                }
                //Since for none we don't need goalId
                if (testSectionLevel != 'none' && _.isEmpty(requB['courseId'])) {
                    this.errorMsg['courseId'] = "required *";
                    errorCount++;
                }
            }
            //For sections
            if (Array.isArray(requB[i])) {

                requB[i].forEach((ob: any, j: number) => {
                    //create an empty array with sections
                    if (!this.errorMsg['sections'])
                        this.errorMsg['sections'] = [];

                    if (!this.errorMsg['sections'][j]) {
                        this.errorMsg['sections'][j] = {};
                    }

                    //Since this is in OR conditions
                    let isAutoPick = ob["autoPickSelection"];
                    let courseSyllabusId = ob["courseSyllabusId"];
                    if (!isAutoPick && _.isEmpty(courseSyllabusId) && testSectionLevel != 'none') {
                        this.errorMsg['sections'][j]["courseSyllabusId"] = "required *";
                        errorCount++;
                    }
                    if (!ob["name"] && testSectionLevel == 'none') {
                        this.errorMsg['sections'][j]["name"] = "required *";
                        errorCount++;
                    }

                    ob["subSection"].forEach((ob2: any, l: number) => {
                        //Loop over subsections and initilize with empty array
                        if (!this.errorMsg['sections'][j]['subSection']) {
                            this.errorMsg['sections'][j]['subSection'] = [];
                        }
                        if (!this.errorMsg['sections'][j]['subSection'][l]) {
                            this.errorMsg['sections'][j]['subSection'][l] = {};
                        }
                        if (!ob2.name) {
                            this.errorMsg['sections'][j]['subSection'][l]["name"] = "required *";
                            errorCount++;
                        }
                        if (parseInt(ob2.noOfQuestions) == 0) {
                            this.errorMsg['sections'][j]['subSection'][l]["noOfQuestions"] = "required *";
                            errorCount++;
                        }
                        if(ob2.mandatoryQuestionCount === 0) {
                            this.errorMsg['sections'][j]['subSection'][l]["mandatoryQuestionCount"] = "required *";
                            errorCount++;
                        }
                        if (testSectionLevel != 'none' && ob2.quesCodeAllowed == -1) {
                            this.errorMsg['sections'][j]['subSection'][l]["quesCodeAllowed"] = "required *";
                            errorCount++;
                        }

                    })
                })

            }
        }
        return errorCount;
    }

    gotFromChild = (data: TestTemplateBody) => {
        this.setState({
            testTemplateReq: createDeepCopy(data)
        });
    }
    handleSearchChange=()=>{
        const{searchText}=this.state;
      this.props.handleSearchQuery(searchText);
    }  
    getEmptyScreen = () => {
        const { classes} = this.props;
        return (
            <Grid container justify="center" alignItems="center" className={classes.emptyState}>
                <Grid item xs={12} className={classes.textCenter}>
                    <img src="/assets/svg/no-filter-feedback.svg" alt="No Templates"/>
                </Grid>
                <Grid item xs={12} className={classes.textCenter}>
                    <h2 className={classes.emptyheadingText}>No Templates are created!</h2>
                </Grid>
               <Typography className={classes.subText}>You haven't made any templates for this selection yet.</Typography>
            </Grid>
        );
        
    }

    getButton = () => {
        const { classes, isFieldDisabled, selectedTemplateTypeFilter } = this.props;
        return (
            ACLService.checkModulePermission(selectedTemplateTypeFilter === TEST_TEMPLATE_TYPES.DEFAULT ? PERMISSION_CONTENT_TYPES.DEFAULT_TEST_TEMPLATE : PERMISSION_CONTENT_TYPES.CUSTOM_TEST_TEMPLATE, USER_RIGHTS.EDIT) &&
            <Button
                id="headerAction"
                variant="contained"
                color="primary"
                className={[classes.createTemplateBtn, classes.customBtn].join(' ')}
                onClick={() => this.viewCreateTemplate(this)}

            >
                Create Template
            </Button>
        )
    }
    
    render() {
        const {
            classes,
            templatesList,
            activeTestTypeId,
            toPage,
            recordCount,
            searchQuery,
            handleSearchQuery,
            selectedTemplateTypeFilter,
            activeTestType,
        } = this.props;
        const { durationType, isCreate, isTemplatePresent,searchText } = this.state;
        const otherDialogProps = {
            fullWidth: true,
            maxWidth: 'md',
            scroll: 'body',
        };
        let templList;
        if ((searchQuery.length>0) || (templatesList && templatesList.length > 0)) {
            templList =
                <>
                    <Grid item xs={12} >
                        <TemplateList templatesList={templatesList} activeTSetting={this.props.activeTSetting} selectedTemplateTypeFilter={this.props.selectedTemplateTypeFilter} onTemplateRuleEdit={this.props.onTemplateRuleEdit}/>
                        <Grid container xs={12} justify="flex-end" direction="row">
                            <Button
                                disabled={this.props.skip == 0 ? true : false}
                                className={[classes.createTemplateBtn, classes.paginationBtn].join(' ')}
                                onClick={() => this.props.toPage(0)}
                            >
                                First
                        </Button>
                        &nbsp;
                        <Button
                                disabled={this.props.skip == 0 ? true : false}
                                className={[classes.createTemplateBtn, classes.paginationBtn, classes.arrowBtn].join(' ')}
                                onClick={() => this.props.prevPage()}
                            >
                                <ArrowLeftIcon />
                            </Button>
                        &nbsp;
                        <span className={classes.recordCount}>{this.props.skip + 1} - {Math.min(this.props.skip + 10, recordCount)} of {recordCount}</span>
                        &nbsp;
                        <Button
                                disabled={templatesList.length < 10}
                                className={[classes.createTemplateBtn, classes.paginationBtn, classes.arrowBtn].join(' ')}
                                onClick={() => this.props.nextPage()}
                            >
                                <ArrowRightIcon />
                            </Button>
                        &nbsp;
                        <Button
                                disabled={templatesList.length < 10}
                                className={[classes.createTemplateBtn, classes.paginationBtn].join(' ')}
                                onClick={() => this.props.toPage(Math.floor(recordCount / 10))}
                            >
                                Last
                        </Button>
                        </Grid>
                    </Grid>
                </>;

        }
        else {
            templList =
                <Grid item xs={12}>
                    {ACLService.checkModulePermission(selectedTemplateTypeFilter === TEST_TEMPLATE_TYPES.DEFAULT ? PERMISSION_CONTENT_TYPES.DEFAULT_TEST_TEMPLATE : PERMISSION_CONTENT_TYPES.CUSTOM_TEST_TEMPLATE, USER_RIGHTS.EDIT) ?
                        <Grid>
                        </Grid>
                        :
                        <Grid item className={classes.center}>
                            <img alt="no content" className={classes.img} src='/assets/img/mylibrary/no-content.png' />
                            <Typography variant="h6" className={classes.heading} gutterBottom>Oh Snap! We can't find it</Typography>
                            <Typography variant="caption" color="textSecondary" gutterBottom>Currently there are no templates created</Typography>
                        </Grid>
                    }
                    {this.getEmptyScreen()}
                </Grid>;
        }
        return (
            <>
                <Grid container
                    spacing={0}
                    className={classes.root}>
                    <Grid item xs={5}>
                        <Typography variant="h6" className={classes.templateHeading}>
                            {activeTestType && activeTestType.name} Template{(templatesList || []).length !== 1 ? 's' : ''}
                        </Typography>
                    </Grid>
                    <Grid item xs={7} className={classes.headerActions}>
                            {this.getButton()}
                    </Grid>
                    <Grid item xs={12} className={classes.searchContainer}>
                        <img src="/assets/svg/contentRequest/search-icon.svg" />
                        <input type="text"
                            value={searchText}
                            onChange={(event:any) => {
                                this.setState({searchText:event.target.value},()=>{this.handleSearchChange()});
                            }
                            }
                            // onKeyPress={(event: any) => {this.handleEnterSearch(event) }}
                            placeholder='Search'
                        />
                    </Grid>
                    { templList}

                </Grid>
                {/* {
                    (!isTemplatePresent)
                        ?
                        templList
                        :
                        ''
                } */}
                <MyPATDialog
                    dialogOpen={isCreate}
                    otherDialogProps={otherDialogProps}
                    onDialogClose={this.viewCreateTemplate.bind(this)}
                    onDialogBack={this.viewCreateTemplate.bind(this)}
                    customButtonVariant = "withoutBorderCloseIcon"
                    variantHeader="leftHeader"
                    classes={{ perfectScrollbar: ` ${classes.customScroll}` }}
                    customDialogTitle={
                        <>
                            <Grid container justify="space-between" alignItems="center">

                                <Grid item xs={5}>
                                    <Grid container alignItems="flex-start">
                                        <Typography variant="h5" noWrap>Create Test Template</Typography>
                                    </Grid>
                                </Grid>

                                <Grid item xs="auto">
                                    &nbsp;&nbsp;
                                    <MyPATIconButton buttonVariant="withoutBorderCloseIcon"
                                        onClick={this.viewCreateTemplate.bind(this)}>
                                        <CloseIcon />
                                    </MyPATIconButton>
                                </Grid>
                            </Grid>
                        </>
                    }
                    customDialogActions={
                        <Grid>
                            <Button 
                                classes={{ root: classes.btnOutline}}
                                onClick={this.viewCreateTemplate.bind(this)}
                               >
                                Cancel
                            </Button>
                            <Button 
                                classes={{ root: classes.btnPrimary }}
                                onClick={this.saveTestTemplate.bind(this)}
                               >
                                Save
                            </Button>
                        </Grid>
                    }
                > 
                    <CreateTestTemplate transferToParent={this.gotFromChild} activeTSetting={this.props.activeTSetting} />
                </MyPATDialog>
            </>
        )
    }
}

const mapStateToProps = (state: any) => ({
    userData: state.loginData.userData,
    loggedInUserData:  state.loginData.userData &&  state.loginData.userData.loggedInUserData,
    showLicenseExpiredDialog:  state.loginData.userData &&  state.loginData.userData.showLicenseExpiredDialog,
    isPostExpiryDays: state.loginData.userData && state.loginData.userData.isPostExpiryDays,
    activeTestType: getPropertyValue(state, 'testTemplate.testTemplateType.activeTestType', {})
    // map state to props here
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
    {
        testTemplateList,
        showMsg,
        toggleLicenseExpiredDialog,
        setLoggedInUser
    },
    dispatch
);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TemplateContent));